import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import "./assets/css/style.css"
import "react-quill/dist/quill.snow.css";

// const store = createStore(combineReducers, applyMiddleware(Thunk));

import store from "./store"
import { styled } from "@material-ui/core"

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
